import React from 'react';

import ContentView from '../../components/ui-controls/layout/ContentView';
import FlatListMenu from '../../components/ui-controls/MenuFlatList';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {rootStore} from '../../stores/rootStore';
import {useStores} from '../../stores/use-stores';

enum CardOptions {
  BUY_A_GIFT_CARD = 'Buy a Gift Card',
  CHECK_A_GIFT_CARD_BALANCE = 'Check a Gift Card Balance',
  HOW_TO_REDEEM_A_GIFT_CARD = 'How to Redeem a Gift Card',
  TERMS_AND_CONDITIONS = 'Terms and Conditions',
}

const GiftCardsOptionsScreen = ({
  navigation,
}: RouteNavigatorScreenProps<AppRoute.GIFT_CARDS_OPTIONS>) => {
  const {promotionsStore} = useStores();

  const isGiftCardStore =
    rootStore.shopSelectionStore?.isSelectedStoreGiftCardStore();

  const handleMenuItemPress = (item: any) => {
    switch (item.id as CardOptions) {
      case CardOptions.BUY_A_GIFT_CARD:
        if (isGiftCardStore) {
          navigation.navigate(AppRoute.GIFT_CARDS_MAIN);
        } else {
          promotionsStore.navigateToGiftCardsPromotionOrLoadingScreen(
            navigation.navigate,
          );
        }
        break;
      case CardOptions.CHECK_A_GIFT_CARD_BALANCE:
        navigation.navigate(AppRoute.GIFT_CARDS_CHECK_BALANCE);
        break;
      case CardOptions.HOW_TO_REDEEM_A_GIFT_CARD:
        navigation.navigate(AppRoute.GIFT_CARDS_HOW_TO_REDEEM);
        break;
      case CardOptions.TERMS_AND_CONDITIONS:
        navigation.navigate(AppRoute.GIFT_CARDS_TERMS_AND_CONDITIONS);
        break;
      default:
        break;
    }
  };

  const menuItems = [
    {id: CardOptions.BUY_A_GIFT_CARD, name: 'Buy a Gift Card'},
    {
      id: CardOptions.CHECK_A_GIFT_CARD_BALANCE,
      name: 'Check a Gift Card Balance',
    },
    {
      id: CardOptions.HOW_TO_REDEEM_A_GIFT_CARD,
      name: 'How to Redeem a Gift Card',
    },
    {
      id: CardOptions.TERMS_AND_CONDITIONS,
      name: 'Terms and Conditions',
    },
  ];

  return (
    <ContentView testID="information-screen">
      <FlatListMenu data={menuItems} onPressItem={handleMenuItemPress} />
    </ContentView>
  );
};

export default GiftCardsOptionsScreen;
